import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'editCategory';

const reducersKeys = {
  editRequest: 'editRequest',
  editSuccess: 'editSuccess',
  editFailure: 'editFailure',
};

const initialState = {
  data: null,
  showModal: false,
  edited: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.editRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.editSuccess]: (state) => {
      state.loading = false;
      state.showModal = false;
      state.edited = true;
    },
    [reducersKeys.editFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
    openModal: (state, { payload }) => {
      state.edited = false;
      state.data = payload.data;
      state.showModal = true;
    },
    closeModal: (state) => {
      state.data = null;
      state.showModal = false;
    },
  },
});

export const editCategoryCreate = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
